export default "__VITE_ASSET__fc473cc6__"